import { datalabHttp } from '@dbl/services/common';
import { DATALAB_EDITOR } from '@dbl/core/global';

import type {
  IFeaturePrivilegesData,
  IGetFeaturePrivilegesRequest,
  ISaveSharedEditorsRequest,
  TGetFeaturePrivilegesData,
  TSaveSharedEditorsData,
} from './types';

/**
 * 保存某张图表/报表/数据集/SQL 视图的共享编辑者列表（产品：访问设置）。
 *
 * 命名用 `save` 而非 `add`：弹窗一次性提交完整编辑者名单（可增删改权限），
 * 不是单条追加；后端路径 `/share/add` 仅作 wire 引用。
 *
 * 接口：`POST /api/v1/datalab/share/add`；存量：`setShareEditAccess`。
 */
export function saveSharedEditors(
  params: ISaveSharedEditorsRequest,
): Promise<TSaveSharedEditorsData> {
  return datalabHttp({
    url: '/api/v1/datalab/share/add',
    method: 'post',
    data: params,
    useCustomTips: true,
  });
}

/**
 * 拉取当前用户在本游戏下的功能权限（控制新建报表/图表、发布模型等按钮是否可用）。
 *
 * 接口：`POST /api/v1/datalab/privileges`；
 */
export function getPrivileges(
  params: IGetFeaturePrivilegesRequest,
): Promise<TGetFeaturePrivilegesData> {
  return datalabHttp({
    url: '/api/v1/datalab/privileges',
    method: 'post',
    data: params,
    formatData: (data: IFeaturePrivilegesData): TGetFeaturePrivilegesData => {
      const privilegesData: IFeaturePrivilegesData = (data ?? {});
      if (Array.isArray(privilegesData.main_game)) {
        privilegesData.main_game.push({ privilege: DATALAB_EDITOR.WhiteSpace });
      } else {
        privilegesData.main_game = [{ privilege: DATALAB_EDITOR.WhiteSpace }];
      }
      return privilegesData;
    },
  });
}
